define('config',{
	baseUrl: '/analytics-ui/ui/',
	resetPasswdUrl: '/analytics-ui/ui/reset-password',
	apiRoot: '/analytics/rest/',
	textRegex: /^[-\w\s-,.'()"?:;@/]+$/
});

